import { useMemo } from "react";
import { useRouter } from "./useRouter";

export const useQueryParams = () => {
	const { getParams } = useRouter();
	return useMemo(getParams, [getParams]);
}